<script lang="ts">

    import Router from "svelte-spa-router";
    import { routes } from "./routes";
    import Sidebar from "./Sidebar.svelte";
    import Topnav from "./Topnav.svelte";
    import { connectionStatus } from "./communication";
    import { me } from "./user";
    import { VERSION } from "./webpack";
    import { onMount } from "svelte";
    

  
    let sidebar: Sidebar;
    let sidebarOpen = false;
    
    function toggleSidebar() {
        sidebarOpen = !sidebarOpen;
        console.log('Sidebar toggled:', sidebarOpen);
    }

    function closeSidebar() {
        sidebarOpen = false;
        console.log('Sidebar closed');
    }

    onMount(() => {
        // Close sidebar when clicking outside on mobile
        const handleClickOutside = (event: MouseEvent) => {
            const target = event.target as HTMLElement;
            if (sidebarOpen && !target.closest('.sidebar-container') && !target.closest('.hamburger-menu')) {
                closeSidebar();
            }
        };

        document.addEventListener('click', handleClickOutside);
        
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    });
    
</script>
{#if !$connectionStatus}
    <div style="position: absolulte; top: 0px; left: 0px; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.5); z-index: 1000; display: flex; align-items: center; justify-content: center;">
        <div class="ui icon negative message" style="width: auto">
            <i class="notched circle loading icon"></i>
            <div class="content">
                <div class="header">
                Connecting
                </div>
                <p>Connection lost, trying to connect again</p>
            </div>
        </div>
    </div>
{:else if $me}
    
    <Topnav on:sidebartoggle={toggleSidebar} />

    <div class="pusher">
        <div class="full height" style="margin-top: 3em;">

            <div class="sidebar-container" class:sidebar-open={sidebarOpen}>
                <Sidebar bind:this={sidebar} />
            </div>

            <div class="article" class:article-mobile={sidebarOpen}>
                <Router routes={$routes} restoreScrollState={true}/>
            </div>

            <div style="text-align: center; color: lightgrey; ">
                {VERSION ?? "no data"}
            </div>
        </div>
    </div>
{:else}
    <div class="full height" style="width: 100%; height: 100%; display: flex; flex-direction: column;">
        <div class="article" style="flex-grow: 1">
            <Router routes={$routes} restoreScrollState={true}/>
        </div>

        <div style="text-align: center; color: lightgrey; ">
            {VERSION ?? "no data"}
        </div>
    </div>
{/if}



<style global>
    body
    {
        zoom: 125%;
    }

    /* Responsive styles */
    @media (max-width: 768px) {
        body {
            zoom: 100%;
        }
        
        .article {
            margin-left: 0 !important;
            transition: margin-left 0.3s ease;
            width: 100%;
            overflow-y: auto;
            overflow-x: auto;
            height: calc(100vh - 3em);
            padding: 1rem;
        }
        
        .article-mobile {
            margin-left: 0 !important;
            width: 100%;
            overflow-y: auto;
            overflow-x: auto;
            height: calc(100vh - 3em);
            padding: 1rem;
        }
        
        .sidebar-container {
            position: fixed;
            top: 0;
            left: 0;
            height: 100vh;
            z-index: 1000;
            transform: translateX(-100%);
            transition: transform 0.3s ease;
            width: 250px;
            overflow-y: auto;
            overflow-x: hidden;
        }
        
        .sidebar-container.sidebar-open {
            transform: translateX(0) !important;
        }
        
        /* Overlay for mobile */
        .sidebar-container::before {
            content: '';
            position: fixed;
            top: 0;
            left: 0;
            width: 100vw;
            height: 100vh;
            background-color: rgba(0, 0, 0, 0.5);
            z-index: -1;
            opacity: 0;
            transition: opacity 0.3s ease;
            pointer-events: none;
        }
        
        .sidebar-container.sidebar-open::before {
            opacity: 1;
            pointer-events: auto;
        }

        /* Show hamburger menu on mobile */
        .hamburger-menu {
            display: flex !important;
        }
    }

    /* Desktop styles */
    @media (min-width: 769px) {
        .sidebar-container {
            position: fixed;
            top: 0;
            left: 0;
            height: 100vh;
            z-index: 9999;
            transform: translateX(0) !important;
            width: 150px;
            overflow-y: auto;
            overflow-x: hidden;
        }
        
        .article {
            margin-left: 150px !important;
            width: calc(100% - 150px) !important;
            max-width: calc(100% - 150px) !important;
            overflow-y: auto;
            overflow-x: auto;
            height: calc(100vh - 3em);
            padding: 1rem;
            position: relative;
            z-index: 1;
        }

        /* Hide hamburger menu on desktop */
        .hamburger-menu {
            display: none !important;
        }
    }
</style>